import img from './img.jpeg';
import img1 from './img1.jpeg';

const all_images ={
    img,
    img1
};
export default all_images;